import { render, staticRenderFns } from "./calculator.vue?vue&type=template&id=2f5c6baf&scoped=true&lang=pug&"
import script from "./calculator.vue?vue&type=script&lang=js&"
export * from "./calculator.vue?vue&type=script&lang=js&"
import style0 from "./calculator.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./calculator.vue?vue&type=style&index=1&id=2f5c6baf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5c6baf",
  null
  
)

export default component.exports